import axios from "axios";
import showToast from "../../showToast";

const backendURL = process.env.REACT_APP_BACKEND_URL;

const backendInstance = axios.create({
  baseURL: backendURL,
  withCredentials: true,
});

export const fetchCsrfToken = async () => {
  try {
    const { data } = await backendInstance.get("/csrf-token");
    return data.csrfToken;
  } catch (error) {
    return null;
  }
};

backendInstance.interceptors.request.use(
  async (config) => {
    if (["post", "put", "delete"].includes(config.method.toLowerCase())) {
      const csrfToken = await fetchCsrfToken();
      if (csrfToken) {
        config.headers["x-csrf-token"] = csrfToken;
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

backendInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 403 || error.response?.status === 401) {
      document.cookie = "token=; Max-Age=0";
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");

      showToast("error", "Phiên đăng nhập đã hết hạn! Vui lòng đăng nhập lại.");
      setTimeout(() => {
        window.location.href = "/login";
      }, 1500);
    }
    return Promise.reject(error);
  }
);

export default backendInstance;
